export default __webpack_public_path__ + "static/Mohawk-9d5e5bdc879eb44e7c395043a9242c66.svg";